<div class="general-informations" [formGroup]="form()">
    <div class="general-informations__togglers">
        <h4>Données générales</h4>
        <div class="d-flex flex-row align-items-center mb-1">
            <p-inputSwitch formControlName="excludeNotIncludedPoints"></p-inputSwitch>
            <label class="ms-2 input-label">Exclure les points non inclus</label>
        </div>
        <div class="d-flex flex-row align-items-center mb-1">
            <p-inputSwitch formControlName="includeCancelPoints"></p-inputSwitch>
            <label class="ms-2 input-label">Inclure les points annulés</label>
        </div>
        <div class="d-flex flex-row align-items-center mb-1">
            <p-inputSwitch formControlName="myPointsToCorrect"></p-inputSwitch>
            <label class="ms-2 input-label">Mes points à corriger</label>
        </div>
        <div class="d-flex flex-row align-items-center mb-1">
            <p-inputSwitch formControlName="searchIntoContent"></p-inputSwitch>
            <label class="ms-2 input-label">Rechercher dans le contenu</label>
        </div>
        <div class="d-flex flex-row align-items-center ">
            <p-inputSwitch formControlName="onlyUnreads"></p-inputSwitch>
            <label class="ms-2 input-label">Uniquement les non-lus</label>
        </div>
    </div>
    <div class="general-informations__form ">
        <div class="d-flex flex-column mb-2 col-12">
            <label class="input-label">Mot clé</label>
            <input pInputText formControlName="keyword">
        </div>
        <div class="row mb-2">
            @if(rights().can('viewCurrentPointType')) {
            <div class="d-flex flex-column " [class.col-12]="rights().cannot('viewCurrentStatus')"
                [class.col-6]="rights().can('viewCurrentStatus')">
                <label class="input-label">Type(s) de point</label>
                <p-multiSelect [appendTo]="'body'" [loading]="fetchingPointTypes()" [disabled]="fetchingPointTypes()"
                    [style]="{width: '100%', maxWidth: 'calc(100%-8px)', minWidth: '100%'}" formControlName="pointTypes"
                    optionLabel="description" [showClear]="true" [options]="pointTypesOptions()"
                    [ngStyle]="{width: '100%', maxWidth: 'calc(100%-8px)', minWidth: '100%'}"></p-multiSelect>
            </div>
            }
            @if(rights().can('viewCurrentStatus')) {
            <div class="d-flex flex-column " [class.col-12]="rights().cannot('viewCurrentPointType')"
                [class.col-6]="rights().can('viewCurrentPointType')">
                <label class="input-label">Statut(s) du point</label>
                <p-multiSelect [appendTo]="'body'" [loading]="fetchingPointStatuses()"
                    [disabled]="fetchingPointStatuses()" [style]="{width: '100%'}" optionLabel="description"
                    [showClear]="true" [options]="pointStatusesOptions()" [style]="{width: '100%'}"
                    formControlName="pointStatuses"></p-multiSelect>
            </div>
            }
        </div>
        <div class="row">
            <div class="d-flex flex-column position-relative" [class.col-12]="rights().cannot('viewCurrentMatter')"
                [class.col-6]="rights().can('viewCurrentMatter')">
                <label class="input-label">Service(s)</label>
                <span class="position-absolute" style="left: -25px;bottom: 5px;" (click)="selectAllServices()">
                    <idel-rounded-button [severity]="'primary'" [icon]="'bi bi-ui-checks'"
                        [tooltip]="'Sélectionner tous les services'"
                        [disabled]="!servicesOptions().length"></idel-rounded-button>
                </span>
                <p-treeSelect [appendTo]="'body'" [loading]="fetchingServices()" [disabled]="fetchingServices()"
                    [options]="servicesOptions()" [style]="{'max-width': '100%'}" optionValue="data"
                    [selectionMode]="'checkbox'" class="treeSelect p-fluid" formControlName="services"
                    [propagateSelectionDown]="false" [propagateSelectionUp]="false"></p-treeSelect>
            </div>
            @if(rights().can('viewCurrentMatter')) {
            <div class="d-flex flex-column col-6">
                <label class="input-label">Matière(s)</label>
                <p-multiSelect [appendTo]="'body'" [loading]="fetchingMatters()" [disabled]="fetchingMatters()"
                    [style]="{width: '100%'}" optionLabel="description" [showClear]="true" [options]="mattersOptions()"
                    formControlName="matters"></p-multiSelect>
            </div>
            }
        </div>
    </div>
</div>